export default __webpack_public_path__ + "static/media/pro-logo.84c2c35c.svg";